/* eslint-disable */
export async function OpenIframe(data) {
  var win = window.open()
  return win.document.write(
    '<iframe src="' +
      data +
      '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
  )
}
